/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Subscription SKU tier for the team
 * @export
 */
export const ControlSku = {
    Identity: 'identity',
    Adr: 'adr',
    Data: 'data'
} as const;
export type ControlSku = typeof ControlSku[keyof typeof ControlSku];


export function ControlSkuFromJSON(json: any): ControlSku {
    return ControlSkuFromJSONTyped(json, false);
}

export function ControlSkuFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSku {
    return json as ControlSku;
}

export function ControlSkuToJSON(value?: ControlSku | null): any {
    return value as any;
}

